<h3 mat-dialog-title>
  Ledger Voucher Details – {{ data.page_name || '-' }}
</h3>
<div class="card-body table-responsive">
  <table class="table table-hover">
    <thead class="text-warning">
      <tr>
        <th>Voucher No</th>
        <th>Voucher Type</th>
        <th>Branch</th>
        <th>Profit / Cost Center</th>
        <th>Section</th>
        <th>Store</th>
        <th>Date</th>
        <th class="text-end">Cr Amount</th>
        <th class="text-end">Dr Amount</th>
      </tr>
    </thead>

    <tbody>

      <tr *ngFor="let v of vouchers">
        <td>
          <a class="voucher-link" (click)="ledgerbookdetailsModal(v)">
            {{ v.voucher_no }}
          </a>
        </td>

        <td> <a class="voucher-link" (click)="ledgerbookdetailsModal(v)">
            {{ v.voucher_type }}
          </a></td>
        <td>{{ v.branch_name || '-' }}</td>
        <td>{{ v.profit_cost_name || '-' }}</td>
        <td>{{ v.section_name || '-' }}</td>
        <td>{{ v.store_name || '-' }}</td>
        <td>{{ v.date | date:'dd-MM-yyyy' }}</td>
        <td class="text-end">{{ v.cr_amount || 0 }}</td>
        <td class="text-end">{{ v.dr_amount || 0 }}</td>
      </tr>

      <tr *ngIf="vouchers.length === 0">
        <td colspan="9" class="text-center">No vouchers found</td>
      </tr>

    </tbody>
  </table>

</div>

<mat-dialog-actions align="end">
  <!-- <button mat-button (click)="close()">Close</button> -->
  <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
</mat-dialog-actions>